import { PassengersValues } from 'pages/avia/purchase-form/model'

import { DATE_FORMAT_LIST } from 'shared/constants/dateFormatList'
import { dateFormat } from 'shared/lib/dateFormat'

export const prepareDocuments = (adult: PassengersValues) => {
  return {
    middle_name: adult.middleName || '',
    document_type: adult.passport,
    first_name: adult.firstName,
    last_name: adult.lastName,
    document_number: adult.serialDocuments,
    document_expire: adult.documentExpirationDate,
    date_of_birth: dateFormat(
      adult.dateOfBirth,
      DATE_FORMAT_LIST.YEAR_FULL_DATE,
    ),
    date_of_issue: null,
    country_of_issue: null,
    gender: adult.gender,
    citizenship: adult.citizenship,
  }
}
